module.exports = __webpack_public_path__ + "img/11.0f11eac4.jpg";